



















import { Vue, Component } from 'vue-property-decorator';
import PaymentFileFilter from '@/domain/payment/entity/payment-file-filter.entity';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import Response from '@/domain/response.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import EventBus, { Event } from '@/event.bus';
import PaymentFileService from '@/domain/payment/service/payment-file-service';
import Pagination from '@/domain/pagination.entity';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import PaymentFileDatatable from './payment-file-datatable.component.vue';
import FilterComponent from './payment-file-filter.component.vue';

@Component({ components: { FilterComponent, PaymentFileDatatable } })

export default class PaymentFile extends Vue {
  businessUnitId: string = '';

  filter = PaymentFileFilter.of({});

  pagination: Pagination= new Pagination();

  paymentFiles: PaymentFile[] = [];

  loading: boolean = true;

  updateField(field: string, value: any): void {
    this.filter[field] = value;
  }

  loadPaymentFiles(): void {
    if (!this.businessUnitId) return;
    this.loading = true;
    PaymentFileService.getPaymentesFiles(
      this.businessUnitId,
      this.filter.toRequest(),
      this.pagination,
    ).then((response: Response) => {
      this.pagination.total = response.totalElements;
      this.pagination.pageCount = response.totalPages;
      this.paymentFiles = response.content;
    }).catch(VbSnackbarService.handleHttpError).finally(() => { this.loading = false })
  }

  updatePagination(pagination: Pagination) {
    this.pagination = pagination;
    this.pagination.verifyPage();
    this.loadPaymentFiles();
  }

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && (this.$route.name.includes('payment-file'))) {
        this.businessUnitId = businessUnit.id;
        this.loadPaymentFiles();
      }
    })
    this.loadPaymentFiles();
  }
}

